import { render, staticRenderFns } from "./WriteMultipleDocs.vue?vue&type=template&id=166ced1e&scoped=true"
import script from "./WriteMultipleDocs.vue?vue&type=script&lang=js"
export * from "./WriteMultipleDocs.vue?vue&type=script&lang=js"
import style0 from "./WriteMultipleDocs.vue?vue&type=style&index=0&id=166ced1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ced1e",
  null
  
)

export default component.exports